import { Api } from '../services/api';

export function loginRequest(data) {
  return Api.post('/oauth', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
